import type { ComponentProps, ComponentType } from 'react';

import {
  BoxModelIcon,
  ButtonIcon,
  CodeIcon,
  ColumnsIcon,
  DividerHorizontalIcon,
  GroupIcon,
  HeadingIcon,
  ImageIcon,
  PersonIcon,
  TextIcon,
} from '@radix-ui/react-icons';

import type { TReaderDocument } from '@app-evolution-cms/email-builder';

import { GlobeIcon } from '../../../../svg/globe-icon';

export const BLOCK_ICONS = {
  EmailLayout: GlobeIcon,
  Container: BoxModelIcon,
  ColumnsContainer: ColumnsIcon,
  Heading: HeadingIcon,
  Text: TextIcon,
  Button: ButtonIcon,
  Image: ImageIcon,
  Avatar: PersonIcon,
  Divider: DividerHorizontalIcon,
  Spacer: GroupIcon,
  Html: CodeIcon,
} satisfies Record<TReaderDocument[string]['type'], ComponentType<ComponentProps<typeof TextIcon>>>;
